import { readStoredTheme } from '../../helpers/theme'
import { UserPreferencesAction } from './actions'
import { UserPreferences } from './type'

export interface State {
  userPreferences: UserPreferences
  loaded: boolean
  pending: boolean
  error: boolean
}

export const initialState: State = {
  userPreferences: {
    lastLookInPopup: true,
    askForOrderConfirmation: true,
    minimumTradeSize: 0,
    maximumTradeSize: null,
    maximumTradeSizeIsHardLimit: false,
    cancelBalanceUponPartialTrade: false,
    openfinAutoStart: false,
    openfinStartTime: '',
    muteNotifications: false,
    defaultSpotHedgePreference: '',
    cookieConsentDate: '',
    defaultBidOfferValue: null,
    tobPriceIncrement: null,
    tobSpreadIncrement: null,
    useLightTheme: readStoredTheme()
  },
  loaded: false,
  pending: false,
  error: false
}

export const reducer = (
  state = initialState,
  action: UserPreferencesAction
): State => {
  switch (action.type) {
    case 'userPreferences.fetchUserPreferences':
      return { ...state, pending: true, error: false }
    case 'userPreferences.fetchUserPreferencesSuccess':
      return {
        ...state,
        userPreferences: action.payload,
        loaded: true,
        pending: false,
        error: false
      }
    case 'userPreferences.fetchUserPreferencesFailure':
      return { ...state, pending: false, error: true }
    case 'userPreferences.setUserPreferences':
      return { ...state, pending: true, error: false }
    case 'userPreferences.setUserPreferencesSuccess':
      return {
        ...state,
        userPreferences: action.payload.userPreferences,
        loaded: true,
        pending: false,
        error: false
      }
    case 'userPreferences.setUserPreferencesFailure':
      return {
        ...state,
        pending: false,
        error: true
      }
    default:
      return state
  }
}
